<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div>
      <h3 class="p-3">
        {{ $t('daily_summary.invoice_history') }}
      </h3>
    </div>
      <div v-if="tableItems && tableItems.length > 0" class="col-sm-12 list-content result-table nopads">
      <!-- Main table element -->
      <vue3-datatable
          :rows="tableItems"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="40vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
      />
      </div>
      <div v-else class="col-sm-12 list-content result-table nopads">
          <!-- Main table element -->
          <vue3-datatable
              :rows="tableItems"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="40vh"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
          />
      </div>
    <div class="col-12 d-flex justify-content-end">
      <button
        class="btn btn-sm btn-secondary form-button"
        @click.stop="$emit('close')"
      >
        {{ $t('common.close') }}
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {invoiceStateHelper} from '@/components/invoice/InvoiceMixin'
import {restApi} from "@/components/mixins/RestApiMixin";
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'InvoiceHistories',
    components: {Vue3Datatable},
    mixins: [timeUtils, workManagementHelper, restApi, invoiceStateHelper],
    props: {
        summaryItem: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            sortBy: 'created',
            sortDesc: true,
            loading: false,
            sortDirection: 'asc',
            results: [],
            tableItems: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'invoice_state', title: this.$t('daily_summary.invoice_state'), sort: true, headerClass: 'routa-table-header'},
                {field: 'created_date', title: this.$t('daily_summary.date'), sort: true, headerClass: 'routa-table-header'},
                {field: 'created_by', title: this.$t('daily_allowance.user'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        results() {
            let temp = []
            this.results.forEach(result => {
                temp.push({
                    id: result.id,
                    invoice_state: this.getStatesString(result.invoice_state),
                    created_date: this.toLocalTime(result.created_date),
                    created_by: result.created_by ? result.created_by.first_name + ' ' +result.created_by.last_name : '-'
                })
            })
            this.$nextTick(() => this.tableItems = temp )
        }
    },
    mounted() {
        this.fetchTripInvoiceHistories()
    },
    methods: {
        acceptInvoicing: function (item) {
            this.$emit('acceptInvoicing', item)
        },
        fetchTripInvoiceHistories: function () {
            if(this.summaryItem) {
                this.loading = true
                this.restFetchParams(this.tripSummaryUrl + '/' + 'invoicehistories', {summaryId: this.summaryItem.id}, this.handleTripInvoiceHistories)
            }
        },
        handleTripInvoiceHistories(response) {
            this.loading = false
            if(response && response.data) {
                this.results = response.data
            }
        }
    }
}
</script>
